import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import moment from 'moment';

import { CheckCircle, CloseCircleRed, User, CloseAlt } from '~/ui/assets/icons';
import { Popover } from 'antd';
import { PersonRegistrationLog } from '~/typings/entities/person';

import { formatName } from '~/common';
import { BasicListRow, BasicInfo, InfoTitle, InfoText, InfoDateText } from './ProfileResume.styled';
import {
  IconWrapper,
  PopoverCloseAction,
  PopoverContainer,
  PopoverHeader,
  PopoverTitle,
  RegistrationLogList,
} from './RefusedPopover.styled';

type Props = {
  registrationLog: PersonRegistrationLog[];
  icon: ReactNode;
};

const RegistrationStatus = {
  APPROVED: 'Cadastro aprovado',
  REFUSED: 'Cadastro reprovado',
  COMPLETE: 'Cadastro aprovado',
};

export function RefusedPopover({ registrationLog, icon }: Props) {
  const [isMoreTagsPopoverOpen, setIsMoreTagsPopoverOpen] = useState(false);

  const formatDate = useCallback((dateToFormat) => {
    if (!dateToFormat) return 'Indisponível';
    return moment(dateToFormat).format('DD [de] MMMM [de] YYYY • HH[h]mm');
  }, []);

  const handleShowDescription = (logItem) => {
    if (!logItem.userId) {
      return `Aprovação automática`;
    }
    return `${formatName(logItem.userName)}`;
  };

  const popoverContent = (
    <PopoverContainer>
      <PopoverHeader>
        <div>
          <PopoverTitle>Histórico de cadastro</PopoverTitle>
        </div>
        <PopoverCloseAction onClick={() => setIsMoreTagsPopoverOpen(false)}>
          <CloseAlt className="action-icon" width={13} height={13} />
        </PopoverCloseAction>
      </PopoverHeader>
      <RegistrationLogList>
        {registrationLog.map((logItem) => (
          <BasicListRow key={logItem.id}>
            {['COMPLETE', 'APPROVED'].includes(logItem.registrationStatus) ? (
              <CheckCircle className="action-icon" width={16} height={16} />
            ) : (
              <CloseCircleRed className="action-icon" width={16} height={16} />
            )}
            <BasicInfo>
              <InfoTitle>{RegistrationStatus[logItem.registrationStatus] || logItem.registrationStatus}</InfoTitle>
              <InfoText>{handleShowDescription(logItem)}</InfoText>
              <InfoDateText>{formatDate(logItem.operationDate)}</InfoDateText>
            </BasicInfo>
          </BasicListRow>
        ))}
      </RegistrationLogList>
    </PopoverContainer>
  );

  return (
    <Popover
      trigger="click"
      placement="bottom"
      overlayClassName="mt-popover-no-arrow mt-popover-no-padding mt-popover-border-radius"
      visible={isMoreTagsPopoverOpen}
      onVisibleChange={setIsMoreTagsPopoverOpen}
      content={popoverContent}
    >
      <IconWrapper>{icon}</IconWrapper>
    </Popover>
  );
}
